import React from "react";

const ReturnPolicy: React.FC = () => {
  return (
    <section className="flex justify-center bg-[#f5f0b5] text-black py-10 px-4">
      <div className="bg-white rounded-2xl shadow-lg w-full max-w-4xl p-6 md:p-10">
        
        {/* Title */}
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-6">
          Exchange & Return Policy
        </h2>

        {/* Intro */}
        <p className="text-gray-700 text-justify mb-8 leading-relaxed">
          At <span className="font-semibold">Maysam</span>, your satisfaction is our
          priority. We want you to feel confident when shopping with us, which is
          why we offer a simple and transparent exchange and return process.
        </p>

        {/* Exchange Policy */}
        <div className="mb-8 text-left text-justify">
          <h3 className="text-2xl font-semibold mb-3">Exchange Policy</h3>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>Exchange requests can be placed within <strong>7 days</strong> of delivery.</li>
            <li>Items must be unused, unworn, and returned in original packaging with all tags intact.</li>
            <li>
              <strong>Exchange Charges:</strong> The paid amount will be adjusted
              against your replacement product. A nominal <strong>₹150</strong> fee
              will be charged for shipment.
            </li>
            <li>
              Contact us via WhatsApp or email, and our team will guide you through
              the exchange process.
            </li>
          </ul>
        </div>

        {/* Refund Policy */}
        <div className="mb-8 text-left text-justify">
          <h3 className="text-2xl font-semibold mb-3">
            Refund Policy (Limited Cases)
          </h3>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>Refunds are applicable only under the following conditions:</li>
            <li>The order is out of stock.</li>
            <li>The order is not delivered.</li>
            <li>Refunds are initiated within <strong>7 business days</strong>.</li>
            <li>
              Refunds will be processed directly to your original bank account or
              credit card.
            </li>
          </ul>
        </div>

        {/* Eligibility Terms */}
        <div className="mb-8 text-left text-justify">
          <h3 className="text-2xl font-semibold mb-3">
            Refund & Exchange Eligibility
          </h3>
          <ul className="list-disc pl-6 space-y-2 text-gray-700">
            <li>Items must be unused, unworn, and in original packaging with tags intact.</li>
            <li>
              <strong>Customized items</strong> are not eligible for refund or exchange.
            </li>
          </ul>
        </div>

        {/* Contact Section */}
        <div className="bg-gray-50 rounded-xl p-6 text-left text-justify">
          <h3 className="text-2xl font-semibold mb-3">
            How to Initiate a Return or Exchange
          </h3>
          <p className="text-gray-700 mb-4">
            Please contact us through any of the following channels. Our support
            team will assist you with pickup and guide you through the process.
          </p>

          <div className="space-y-2 text-gray-800 font-medium">
            <p>📧 Email: <span className="text-black">maysam_india@gmail.com</span></p>
            <p>📱 WhatsApp: <span className="text-black">+91 85277 56533</span></p>
          </div>
        </div>

      </div>
    </section>
  );
};

export default ReturnPolicy;
